import { differenceInCalendarDays, parseISO } from "date-fns";

/** Days since an ISO date, or null when there's no date. */
export function daysSince(iso: string | null | undefined): number | null {
  if (!iso) return null;
  try {
    return differenceInCalendarDays(new Date(), parseISO(iso));
  } catch {
    return null;
  }
}

/** Relationship warmth on a 0–4 scale from the last interaction:
 *  ≤7 days 4 · ≤14 days 3 · ≤30 days 2 · ≤60 days 1 · older or never 0. */
export function warmth(lastTouch: string | null | undefined): number {
  const d = daysSince(lastTouch);
  if (d == null) return 0;
  if (d <= 7) return 4;
  if (d <= 14) return 3;
  if (d <= 30) return 2;
  if (d <= 60) return 1;
  return 0;
}

/** "today" / "yesterday" / "12 days ago" / "never". */
export function agoLabel(iso: string | null | undefined): string {
  const d = daysSince(iso);
  if (d == null) return "never";
  if (d <= 0) return "today";
  if (d === 1) return "yesterday";
  return `${d} days ago`;
}

export const todayISO = (): string => {
  const now = new Date();
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
};
